<template>
  <div>
    <h2>Account Details</h2>
    <div v-if="loadState === 'loading'">
      <Loader v-bind:size="'large'" />
    </div>
    <div v-if="loadState === 'error'">
      <p>{{accountError}}</p>
    </div>
    <div v-if="loadState === 'success'">
      <div class="row">
        <div class="four columns statname">Username</div>
        <div class="eight columns">{{this.stats.username}}</div>
      </div>
      <div class="row">
        <div class="four columns statname">Invited By</div>
        <div class="eight columns">{{this.stats.invited_by || '[Original User]'}}</div>
      </div>
      <div class="row">
        <div class="four columns statname">Posts Made</div>
        <div class="eight columns">{{this.stats.posts_made}}</div>
      </div>
      <div class="row">
        <div class="four columns statname">Votes Cast</div>
        <div class="eight columns">{{this.stats.votes_cast}}</div>
      </div>
      <div class="row">
        <div class="four columns statname">Winning Suggestions</div>
        <div class="eight columns">{{this.stats.times_won}}</div>
      </div>

      <hr>

      <h2>Invite Friends</h2>
      <p>For now, users have to be invited to participate in Lost In Space by someone already on the platform. This maintains the friendliness of the site, and drastically cuts spam.</p>

      <p>To invite someone to the platform, send them your (personalized) referral link, below:</p>

      <input
        class="u-full-width"
        type="text"
        v-bind:value="getLink()"
        @click="selectLink($event)"
      />

      <p>Or, they can register manually by entering the following token when they register on the Login page:</p>

      <input
        class="u-full-width"
        type="text"
        v-bind:value="inviteToken"
        @click="selectLink($event)"
      />

      <p>Think your token's been stolen? Just click the button below to invalidate your old token and regenerate a new one!</p>

      <button
        class="button"
        @click="regenerate"
      >Regenerate Token</button>
    </div>
  </div>
</template>

<script>
  import Loader from './Loader'
  export default {
    components: { Loader },
    data () {
      return {
        loadState: '',
        stats: {},
        accountError: '',
        inviteToken: ''
      }
    },
    created () {
      this.loadState = 'loading'
      this.$http.get(process.env.API_URL + '/account.php').then(res => {
        if (res.body.status === 'success') {
          this.loadState = 'success'
          this.stats = res.body.data.stats
          this.accountError = ''
          this.inviteToken = res.body.data.invite_token
        } else {
          this.loadState = 'error'
          this.accountError = res.body.data
        }
      })
    },
    methods: {
      getLink () {
        if (this.inviteToken) {
          return 'https://omnomzom.com/login?token=' + this.inviteToken
        } else {
          return 'Loading...'
        }
      },
      regenerate () {
        this.inviteToken = ''
        this.$http.post(process.env.API_URL + '/regenerate.php').then(res => {
          if (res.body.status === 'success') {
            this.inviteToken = res.body.data
          } else {
            this.loadState = 'error'
            this.accountError = res.body.data
            this.inviteToken = ''
          }
        })
      },
      selectLink (evt) {
        evt.target.select()
      }
    }
  }
</script>

<style scoped>
.statname {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Account.vue?1d544632